module.exports = __webpack_public_path__ + "img/modx.e1ec471c.png";